const LayoutForPreview = ({children}) => children;

export default LayoutForPreview;
